import { Box, IconButton, Typography, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import API from "../../api/index";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from '@mui/icons-material/Settings';
import FolderIcon from '@mui/icons-material/Folder';

const TotalNodes = ({ nNodes = 0 }) => {

  const [, setIsAnimating] = useState(false);



  useEffect(() => {
    // Attiva l'animazione se nNodes supera 10
    let limitNodes
    switch (sessionStorage.getItem('tipoLecs')) {
      case 'LECS-CORE-4':
        limitNodes = 800
        break
      case 'LECS-64':
        limitNodes = 150
        break
      case 'LECS-CORE-2':
        limitNodes = 200
        break
      case 'LECS':
        limitNodes = 30
        break
      case 'LECS-CORE-SFP':
        limitNodes = 1500
        break
      default:
        limitNodes = 100
        break
    }

    if (nNodes > limitNodes) {
      setIsAnimating(true);
      sessionStorage.setItem('limitNodesExceeded', true)
    } else {
      setIsAnimating(false);
      sessionStorage.setItem('limitNodesExceeded', false)
    }
  }, [nNodes]);

  return (
    <Typography
      style={{
        color: sessionStorage.getItem("limitNodesExceeded") === "true" && sessionStorage.getItem("limitBandExceeded") === "true" ? "red" : sessionStorage.getItem("limitNodesExceeded") === "true" ? "orange" : "white",
        fontSize: "1rem",
        transition: "color 0.3s ease, transform 0.3s ease",
        animation: sessionStorage.getItem("limitNodesExceeded") === "true" && sessionStorage.getItem("limitBandExceeded") === "true"
          ? "pulse 0.5s infinite alternate, flashColor 0.5s infinite alternate"
          : "none",
      }}
    >
      Active Hosts: {nNodes} {sessionStorage.getItem("limitNodesExceeded") === "true" && sessionStorage.getItem("limitBandExceeded") === "true" && "Please verify your license"}
      {/* Definizione dell'animazione CSS */}
      <style>
        {`
          @keyframes pulse {
            from {
              transform: scale(1);
            }
            to {
              transform: scale(1.2);
            }
          }
          @keyframes flashColor {
            from {
              color: red;
            }
            to {
              color: white;
            }
          }
        `}
      </style>
    </Typography>
  );
}


const TopbarR = ({ customerName }) => {
  const navigate = useNavigate();
  const [nNodes, setNNodes] = useState(0)
  


    const goToPage = () => {
      window.sessionStorage.setItem("selectedTab", "Documentations")
      navigate('/reseller/document');
  }

 

  const handleLogout = () => {
    API.logout({})
      .then(() => {
        sessionStorage.clear();
        navigate("/");
      })
      .catch(() => {
        sessionStorage.clear();
        navigate("/");
      });
  };

 

  const goToInventory = () => {
    navigate('/reseller/myC/status')
  }

  useEffect(() => {
    if (customerName && customerName.length > 0) {
      API.getHosts().then(res => {
        setNNodes(res.data.count)
        sessionStorage.setItem('numberNodes', res.data.count)
      }).catch(err => {
        console.error('[TopbarR] error:', err)
      })
    }
  })

  return (
    <Box
      className="sticky top-0 flex justify-between z-10 h-14 p-2 bg-topbar-dark "
      display="flex"
      justifyContent="space-between"
      gap={10}
    >
      {/* SEARCH BAR */}
      {/* <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box> */}
      <Typography sx={{ fontWeight: 500, fontSize: 20, minHeight: 40 }}>
        {customerName && customerName.length > 0 && (
          <>
            You are looking at the dashboard of
            <span style={{ fontSize: 25, fontWeight: 900, color: '#459296' }}>
              {" " + customerName}
            </span>
          </>
        )}
      </Typography>

      <Stack direction={"row"} spacing={1}>
        {customerName && customerName.length > 0 && (
          <IconButton onClick={goToInventory} sx={{ borderRadius: 1, "&:hover": { backgroundColor: "#ffffff0d" } }}>
            <TotalNodes nNodes={nNodes} />
          </IconButton>
        )}
        <IconButton onClick={() => navigate('/reseller/options')}>
          <SettingsIcon />
        </IconButton>

        <IconButton onClick={goToPage}>
          <FolderIcon />
        </IconButton>

        < IconButton onClick={handleLogout}>
          <LogoutIcon />
        </IconButton>
      </Stack>
    </Box >
  );
};

export default TopbarR;
